export default __webpack_public_path__ + "static/media/business-needs.52db46b6.svg";